import { Authentication } from './Authentication';
import type { AuthenticationOptions } from './types';

export type {
	AnonymousUser,
	ApiUserResponse,
	AuthenticateResponse,
	AuthenticationOptions,
	JwtPayload,
	TokenPair,
	TokensByWorkspaceId,
	User,
	UserAvatar,
	UserPreferences,
} from './types';

export { Authentication, createAuthentication };

/** Default singleton for web app (userSource: 'knockout'). Use createAuthentication() for portal or custom options. */
const authentication = new Authentication();

/**
 * Factory for portal or other apps that need relative login redirect and/or API user source.
 */
function createAuthentication(options: AuthenticationOptions = {}): Authentication {
	return new Authentication(options);
}

export default authentication;
